import { render, staticRenderFns } from "./Abbonamenti.vue?vue&type=template&id=0bfcf2e4&lang=pug"
import script from "./Abbonamenti.vue?vue&type=script&lang=ts"
export * from "./Abbonamenti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports